module.exports = __webpack_public_path__ + "static/InstitutoInternacional-043cd431c130ab8e0a60d2de4f3d218b.png";